module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-hot-loader/index.js
// module id = 536
// module chunks = 0